import { css } from '@linaria/core';
import theme from '../../../theme';
import { top, bottom, left, right } from '../dropdown/dropdown.styles';

export const variants = {
  interactive: css``,
};
export const components = {
  btnClose: css``,
  content: css``,
  beak: css``,
};

export const tooltip = css`
  display: inline-flex;

  & .${components.beak} {
  }

  & .${components.content} {
    max-width: 300px;
    padding: 8px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid ${theme.colors.neutral['30']};
    overflow: visible;
    white-space: pre-line;
    width: max-content;
    top: 100%;

    &.${bottom} {
      &:after {
        border-width: 1px 1px 0 0;
        top: -1px;
      }
    }

    &.${top} {
      bottom: 100%;

      &:after {
        top: auto;
        bottom: calc(-1px - 0.5rem);
        border-width: 0 0 1px 1px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
      }
    }

    &.${left} {
      left: -10px;
      &:after {
        left: calc(10px + 0.25rem);
      }
    }
    &.${right} {
      right: -10px;
      &:after {
        right: calc(10px + 0.25rem);
        left: unset;
      }
    }

    &:after {
      border-style: solid;
      border-color: ${theme.colors.neutral['30']};
      position: absolute;
      display: inline-block;
      pointer-events: none;
      content: ' ';
      z-index: 2;

      width: 0.5rem;
      height: 0.5rem;
      display: block;

      background: inherit;
      top: 0;
      bottom: auto;
      transform: translateY(-50%) rotate(-45deg);
      transform-origin: center;
      left: calc(var(--tooltip-beak-margin, 12px) - 0.25rem);
    }
  }

  & .${components.btnClose} {
    &:hover {
    }
  }
`;
